<div class="emp-drawer-overlay" [class.open]="showFormDialog" (click)="closeDialog()"></div>
<div class="emp-drawer" [class.open]="showFormDialog">

  <div class="ed-hero" [style.background]="formMode === 'view' ? getAvatarColor(form) : '#334155'">
    <button class="ed-close" (click)="closeDialog()"><mat-icon>close</mat-icon></button>

    <div class="ed-hero-row1">
      <div class="ed-avatar" [style.background]="formMode === 'view' ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.18)'">
        <span *ngIf="formMode === 'view'">{{ getInitials(form) }}</span>
        <mat-icon *ngIf="formMode !== 'view'" style="font-size:28px;width:28px;height:28px;color:#fff">person_add</mat-icon>
      </div>
      <div class="ed-hero-info">
        <div class="ed-hero-name">
          {{ formMode === 'view' ? (form.firstName + ' ' + form.lastName) : (formMode === 'add' ? 'Add New Employee' : 'Edit Employee') }}
        </div>
        <div class="ed-hero-sub">
          {{ formMode === 'view' ? (form.designation || form.title || 'Employee') : 'Fill in the details below' }}
        </div>
        <div class="ed-hero-badges" *ngIf="formMode === 'view'">
          <span class="ed-badge" *ngIf="form.employeeId">{{ form.employeeId }}</span>
          <span class="ed-badge" [class.ed-badge-active]="(form.status || '').toLowerCase() === 'active'" [class.ed-badge-inactive]="(form.status || '').toLowerCase() !== 'active'">
            {{ (form.status || '') | titlecase }}
          </span>
          <span class="ed-badge ed-badge-dept" *ngIf="form.departmentName || form.department">
            <mat-icon style="font-size:11px;width:11px;height:11px;vertical-align:middle">domain</mat-icon>
            {{ form.departmentName || form.department }}
          </span>
        </div>
        <span class="ed-unsaved" *ngIf="formDirty && formMode !== 'view'">Unsaved changes</span>
      </div>
    </div>

    <div class="ed-hero-mgr-strip" *ngIf="formMode === 'view' && getManagerDetails(form.managerId)">
      <div class="ed-hero-mgr-left">
        <mat-icon class="ed-hero-mgr-icon">supervisor_account</mat-icon>
        <span class="ed-hero-mgr-label">Reporting to</span>
      </div>
      <div class="ed-hero-mgr-right">
        <div class="ed-hero-mgr-avatar">
          <img *ngIf="getManagerDetails(form.managerId).photo" [src]="getManagerDetails(form.managerId).photo" class="ed-mgr-photo">
          <span *ngIf="!getManagerDetails(form.managerId).photo">{{ getManagerDetails(form.managerId).initials }}</span>
        </div>
        <div class="ed-hero-mgr-text">
          <span class="ed-hero-mgr-id">{{ getManagerDetails(form.managerId).employeeId }}</span>
          <span class="ed-hero-mgr-name">{{ getManagerDetails(form.managerId).name }}</span>
        </div>
        <span class="ed-hero-mgr-role">{{ getManagerDetails(form.managerId).role | titlecase }}</span>
      </div>
    </div>
  </div>

  <div class="ed-tabs">
    <button type="button" class="ed-tab" [class.active]="empDrawerTab === 'personal'" (click)="empDrawerTab = 'personal'">
      <svg class="ed-tab-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
      Job Details
    </button>
    <button type="button" class="ed-tab" [class.active]="empDrawerTab === 'professional'" (click)="empDrawerTab = 'professional'">
      <svg class="ed-tab-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>
      Personal &amp; Identity
    </button>
    <button type="button" class="ed-tab" [class.active]="empDrawerTab === 'address'" (click)="empDrawerTab = 'address'">
      <svg class="ed-tab-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/></svg>
      Contact &amp; Address
    </button>
    <button type="button" class="ed-tab" [class.active]="empDrawerTab === 'education'" (click)="empDrawerTab = 'education'">
      <svg class="ed-tab-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <rect x="4" y="3" width="16" height="18" rx="2"/><path d="M9 3v4h6V3M8 12h8M8 16h5"/></svg>
      Experience &amp; Family
    </button>
    <button type="button" class="ed-tab" [class.active]="empDrawerTab === 'documents'" (click)="empDrawerTab = 'documents'; loadDocuments()">
      <svg class="ed-tab-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
      Documents
      <span class="ed-tab-badge" *ngIf="empDocs.length > 0">{{ empDocs.length }}</span>
    </button>
  </div>

  <div class="ed-body">
    <form (ngSubmit)="submitEmployee()">

      <fieldset class="ed-z" [class.ed-z--ro]="isView" [disabled]="isView">

        <ng-container *ngIf="empDrawerTab === 'personal'">
          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Basic Information</div>
            <div class="ed-z-grid">
              <div class="ed-field"><label class="ed-label">Employee ID <i *ngIf="canEditEmpId" class="ed-editable">(editable)</i></label>
                <input class="ed-input" [class.ed-input-readonly]="!canEditEmpId" [(ngModel)]="form.employeeId" name="employeeId" [placeholder]="form.employeeId ? '' : (canEditEmpId ? 'Enter Employee ID' : 'Auto-generated')" [readonly]="!canEditEmpId" (ngModelChange)="onFormChange()"></div>
              <div class="ed-field"><label class="ed-label">Preferred Name</label>
                <input class="ed-input" [(ngModel)]="form.nickName" name="nickName" (ngModelChange)="onFormChange()" placeholder="Preferred name"></div>
              <div class="ed-field"><label class="ed-label">First Name <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('firstName')" [(ngModel)]="form.firstName" name="firstName" (ngModelChange)="onFormChange()" placeholder="First name"></div>
              <div class="ed-field"><label class="ed-label">Middle Name</label>
                <input class="ed-input" [(ngModel)]="form.middleName" name="middleName" (ngModelChange)="onFormChange()" placeholder="Middle name"></div>
              <div class="ed-field"><label class="ed-label">Last Name <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('lastName')" [(ngModel)]="form.lastName" name="lastName" (ngModelChange)="onFormChange()" placeholder="Last name"></div>
              <div class="ed-field"><label class="ed-label">Email address <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('email')" [(ngModel)]="form.email" name="email" (ngModelChange)="onFormChange()" placeholder="Email address"></div>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Work Information</div>
            <div class="ed-z-grid">
              <div class="ed-field"><label class="ed-label">Department <i>*</i></label>
                <app-custom-select [(ngModel)]="form.departmentId" name="departmentId" (ngModelChange)="onDepartmentChange()" [options]="departments" bindLabel="name" bindValue="id" placeholder="Select Department"></app-custom-select></div>
              <div class="ed-field"><label class="ed-label">Location <i>*</i></label>
                <app-quick-add-select category="location" [(ngModel)]="form.location" name="location" (ngModelChange)="onFormChange()" placeholder="Select Location"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">Designation <i>*</i></label>
                <app-quick-add-select category="designation" [(ngModel)]="form.designation" name="designation" (ngModelChange)="onFormChange()" placeholder="Select Designation"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">Employment Type <i>*</i></label>
                <app-quick-add-select category="employment_type" [(ngModel)]="form.employmentType" name="employmentType" (ngModelChange)="onFormChange()" placeholder="Select Type"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">Employee Status</label>
                <app-quick-add-select category="employee_status" [seedOptions]="statusOptions" [(ngModel)]="form.status" name="status" (ngModelChange)="onFormChange()" placeholder="Select Status"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">Source of Hire <i>*</i></label>
                <app-quick-add-select category="source_of_hire" [(ngModel)]="form.sourceOfHire" name="sourceOfHire" (ngModelChange)="onFormChange()" placeholder="Select Source"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">Date of Joining <i>*</i></label>
                <app-date-picker label="" [(ngModel)]="form.dateOfJoining" name="dateOfJoining" (ngModelChange)="onFormChange()"></app-date-picker></div>
              <div class="ed-field"><label class="ed-label">BGV Status <i>*</i></label>
                <app-quick-add-select category="bgv_status" [(ngModel)]="form.bgvStatus" name="bgvStatus" (ngModelChange)="onBgvStatusChange()" placeholder="Select BGV Status"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">BGV Date</label>
                <app-date-picker label="" [(ngModel)]="form.bgvDate" name="bgvDate" (ngModelChange)="onFormChange()"></app-date-picker></div>
              <div class="ed-field"><label class="ed-label">BGV Aging</label>
                <input class="ed-input ed-input-readonly" [value]="bgvAging()" readonly placeholder="Auto from BGV Date"></div>
              <div class="ed-field"><label class="ed-label">Notice Period (days)</label>
                <input type="number" class="ed-input" [(ngModel)]="form.noticePeriodDays" name="noticePeriodDays" (ngModelChange)="onFormChange()" placeholder="e.g. 90"></div>
              <div class="ed-field"><label class="ed-label">Current Experience</label>
                <input class="ed-input ed-input-readonly" [(ngModel)]="form.currentExperience" name="currentExperience" placeholder="Auto-calculated" readonly></div>
              <div class="ed-field"><label class="ed-label">Total Experience</label>
                <input class="ed-input ed-input-readonly" [(ngModel)]="form.totalExperience" name="totalExperience" placeholder="Auto-calculated" readonly></div>
              <div class="ed-field"><label class="ed-label">Billable <i>*</i></label>
                <app-custom-select [(ngModel)]="form.billable" name="billable" (ngModelChange)="onBillableChange()" [options]="billableOptions" placeholder="Select"></app-custom-select></div>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Hierarchy Information</div>
            <div class="ed-z-grid">
              <div class="ed-field"><label class="ed-label">Reporting Manager <i>*</i></label>
                <app-custom-select [(ngModel)]="form.managerId" name="managerId" (ngModelChange)="onFormChange()" [options]="managersList" bindValue="id" [labelFn]="empNameFn" placeholder="Select Manager"></app-custom-select></div>
              <div class="ed-field"><label class="ed-label">Secondary Reporting Manager</label>
                <app-custom-select [(ngModel)]="form.secondaryReportingManagerId" name="secondaryReportingManagerId" (ngModelChange)="onFormChange()" [options]="managersList" bindValue="id" [labelFn]="empNameFn" placeholder="Select Manager"></app-custom-select></div>
            </div>
          </div>

          <div class="ed-z-sec" *ngIf="isBillable()">
            <div class="ed-z-title ed-z-title--row"><span><span class="ed-z-bar"></span>Roles &amp; Responsibilities</span>
              <button type="button" class="ed-add-row-btn" *ngIf="!isView" (click)="addRoleRow()"><mat-icon>add</mat-icon> Add Row</button>
            </div>
            <p class="ed-z-hint">Allocate the employee to clients &amp; projects. Same client can have multiple projects (e.g. UPL / CyberVisible Support and UPL / GRC).</p>
            <div class="ed-edu-row" *ngFor="let row of rolesRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field"><label class="ed-label">Client Name</label>
                    <div class="ed-cl-row">
                      <app-custom-select [(ngModel)]="row.clientId" [ngModelOptions]="{standalone:true}" [options]="clients" bindLabel="name" bindValue="id" (ngModelChange)="onRoleClientChange(row)" placeholder="Select Client"></app-custom-select>
                      <button type="button" class="ed-cl-add" (click)="openClientModal(row)" title="Add new client">+</button>
                    </div></div>
                  <div class="ed-field"><label class="ed-label">Project</label>
                    <app-custom-select *ngIf="clientProjects(row.clientId).length" [(ngModel)]="row.project" [ngModelOptions]="{standalone:true}"
                      [options]="clientProjects(row.clientId)" placeholder="Select Project"></app-custom-select>
                    <input *ngIf="!clientProjects(row.clientId).length" class="ed-input" [(ngModel)]="row.project" [ngModelOptions]="{standalone:true}"
                      placeholder="Type project (add projects in Clients section)"></div>
                </div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeRoleRow(i)" *ngIf="rolesRows.length > 1 && !isView"><mat-icon>delete_outline</mat-icon></button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="empDrawerTab === 'professional'">
          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Personal Details</div>
            <div class="ed-z-grid">
              <div class="ed-field"><label class="ed-label">Date of Birth <i>*</i></label>
                <app-date-picker label="" [maxDate]="today" [(ngModel)]="form.dateOfBirth" name="dateOfBirth" (ngModelChange)="onFormChange()"></app-date-picker></div>
              <div class="ed-field"><label class="ed-label">Age</label>
                <input class="ed-input ed-input-readonly" [value]="calcAge(form.dateOfBirth)" readonly placeholder="Auto-calculated"></div>
              <div class="ed-field"><label class="ed-label">Citizenship <i>*</i></label>
                <app-quick-add-select category="citizenship" [(ngModel)]="form.citizenship" name="citizenship" (ngModelChange)="onFormChange()" placeholder="Select Citizenship"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">Blood Group <i>*</i></label>
                <app-quick-add-select category="blood_group" [(ngModel)]="form.bloodGroup" name="bloodGroup" (ngModelChange)="onFormChange()" placeholder="Select Blood Group"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">Gender <i>*</i></label>
                <app-quick-add-select category="gender" [seedOptions]="genderOptions" [(ngModel)]="form.gender" name="gender" (ngModelChange)="onFormChange()" placeholder="Select Gender"></app-quick-add-select></div>
              <div class="ed-field"><label class="ed-label">Marital Status <i>*</i></label>
                <app-quick-add-select category="marital_status" [(ngModel)]="form.maritalStatus" name="maritalStatus" (ngModelChange)="onMaritalChange()" placeholder="Select Marital Status"></app-quick-add-select></div>
              <div class="ed-field" *ngIf="isMarried()"><label class="ed-label">Wedding Day</label>
                <app-date-picker label="" [(ngModel)]="form.weddingDay" name="weddingDay" (ngModelChange)="onFormChange()"></app-date-picker></div>
              <div class="ed-field"><label class="ed-label">LinkedIn Profile</label>
                <input class="ed-input" [(ngModel)]="form.linkedinProfile" name="linkedinProfile" (ngModelChange)="onFormChange()" placeholder="LinkedIn URL"></div>
              <div class="ed-field"><label class="ed-label">Ask me about / Expertise</label>
                <input class="ed-input" [(ngModel)]="form.skillSet" name="skillSet" (ngModelChange)="onFormChange()" placeholder="e.g. HTML, Java, MySQL"></div>
              <div class="ed-field"><label class="ed-label">Certifications</label>
                <input class="ed-input" [(ngModel)]="form.certifications" name="certifications" (ngModelChange)="onFormChange()" placeholder="Certifications"></div>
              <div class="ed-field ed-field-full"><label class="ed-label">About Me</label>
                <textarea class="ed-input ed-textarea" [(ngModel)]="form.additionalInfo" name="additionalInfo" rows="3" (ngModelChange)="onFormChange()" placeholder="About me"></textarea></div>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Identity Information</div>
            <div class="ed-z-grid">
              <div class="ed-field" *ngIf="isIndian()"><label class="ed-label">UAN <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('uanNumber')" [(ngModel)]="form.uanNumber" name="uanNumber" (ngModelChange)="onFormChange()" placeholder="UAN number"></div>
              <div class="ed-field"><label class="ed-label">Do you have a Passport? <i *ngIf="!isIndian()">*</i></label>
                <div class="ed-radio-row">
                  <label class="ed-radio"><input type="radio" name="hasPassport" value="yes" [(ngModel)]="form.hasPassport" (ngModelChange)="onPassportChange()"><span>Yes</span></label>
                  <label class="ed-radio"><input type="radio" name="hasPassport" value="no" [(ngModel)]="form.hasPassport" (ngModelChange)="onPassportChange()"><span>No</span></label>
                </div></div>
              <div class="ed-field" *ngIf="isIndian()"><label class="ed-label">PAN <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('panNumber')" [(ngModel)]="form.panNumber" name="panNumber" (ngModelChange)="onFormChange()" placeholder="PAN number"></div>
              <div class="ed-field" *ngIf="form.hasPassport === 'yes'"><label class="ed-label">Passport Number</label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('passportNumber')" [(ngModel)]="form.passportNumber" name="passportNumber" (ngModelChange)="onFormChange()" placeholder="Passport number"></div>
              <div class="ed-field" *ngIf="form.hasPassport === 'yes'"><label class="ed-label">Passport Valid Until</label>
                <app-date-picker label="" [(ngModel)]="form.passportValidUntil" name="passportValidUntil" (ngModelChange)="onFormChange()"></app-date-picker></div>
              <div class="ed-field" *ngIf="isIndian()"><label class="ed-label">Aadhaar <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('aadhaarNumber')" [(ngModel)]="form.aadhaarNumber" name="aadhaarNumber" (ngModelChange)="onFormChange()" placeholder="Aadhaar number"></div>
              <div class="ed-field"><label class="ed-label">Bank Name</label>
                <input class="ed-input" [(ngModel)]="form.bankName" name="bankName" (ngModelChange)="onFormChange()" placeholder="Bank name"></div>
              <div class="ed-field"><label class="ed-label">Bank Account Number</label>
                <input class="ed-input" [(ngModel)]="form.bankAccount" name="bankAccount" (ngModelChange)="onFormChange()" placeholder="Account number"></div>
              <div class="ed-field"><label class="ed-label">IFSC Code</label>
                <input class="ed-input" [(ngModel)]="form.ifscCode" name="ifscCode" (ngModelChange)="onFormChange()" placeholder="IFSC code"></div>
            </div>
            <div class="ed-attach-grid" style="margin-top:14px">
              <app-doc-attach *ngIf="isIndian()" label="PAN Card" docType="pan" [employeeId]="form.id" [doc]="findDoc('pan')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach *ngIf="isIndian()" label="Aadhar Card" docType="aadhaar" [employeeId]="form.id" [doc]="findDoc('aadhaar')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Cancelled Cheque" docType="cancelled_cheque" [employeeId]="form.id" [doc]="findDoc('cancelled_cheque')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Photo" docType="photo" [employeeId]="form.id" [doc]="findDoc('photo')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="empDrawerTab === 'address'">
          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Contact Details</div>
            <div class="ed-z-grid">
              <div class="ed-field"><label class="ed-label">Work Phone Number <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('workPhone')" [(ngModel)]="form.workPhone" name="workPhone" (ngModelChange)="onFormChange()" placeholder="Work phone"></div>
              <div class="ed-field"><label class="ed-label">Personal Mobile Number <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('personalMobile')" [(ngModel)]="form.personalMobile" name="personalMobile" (ngModelChange)="onFormChange()" placeholder="Personal mobile"></div>
              <div class="ed-field"><label class="ed-label">Extension</label>
                <input class="ed-input" [(ngModel)]="form.extension" name="extension" (ngModelChange)="onFormChange()" placeholder="Extension"></div>
              <div class="ed-field"><label class="ed-label">Personal Email Address <i>*</i></label>
                <input class="ed-input" [class.ed-input-error]="isFieldMissing('personalEmail')" [(ngModel)]="form.personalEmail" name="personalEmail" (ngModelChange)="onFormChange()" placeholder="Personal email"></div>
              <div class="ed-field"><label class="ed-label">Seating Location</label>
                <input class="ed-input" [(ngModel)]="form.seatingLocation" name="seatingLocation" (ngModelChange)="onFormChange()" placeholder="e.g. Mumbai"></div>
              <div class="ed-field"><label class="ed-label">Tags</label>
                <input class="ed-input" [(ngModel)]="form.tags" name="tags" (ngModelChange)="onFormChange()" placeholder="Comma-separated tags"></div>
            </div>
            <div class="ed-z-2col" style="margin-top:14px">
              <div class="ed-z-addr">
                <div class="ed-addr-section-title">Present Address</div>
                <input class="ed-input" [(ngModel)]="form.presentAddressLine1" name="presentAddr1" (ngModelChange)="onFormChange()" placeholder="Address line 1">
                <input class="ed-input" [(ngModel)]="form.presentAddressLine2" name="presentAddr2" (ngModelChange)="onFormChange()" placeholder="Address line 2">
                <div class="ed-row">
                  <app-custom-select [(ngModel)]="form.presentCountry" name="presentCountry" (ngModelChange)="onPresentCountryChange()" [options]="countries" placeholder="Country"></app-custom-select>
                  <app-custom-select [(ngModel)]="form.presentState" name="presentState" (ngModelChange)="onPresentStateChange()" [disabled]="!form.presentCountry" [options]="presentStates" placeholder="State"></app-custom-select>
                </div>
                <div class="ed-row">
                  <app-custom-select [(ngModel)]="form.presentCity" name="presentCity" (ngModelChange)="onFormChange()" [disabled]="!form.presentState" [options]="presentCities" placeholder="City"></app-custom-select>
                  <input class="ed-input" [(ngModel)]="form.presentPostalCode" name="presentPostal" (ngModelChange)="onPresentPostalChange()" placeholder="Postal code">
                </div>
              </div>
              <div class="ed-z-addr">
                <div class="ed-addr-section-title">Permanent Address
                  <label class="ed-same-inline"><input type="checkbox" [(ngModel)]="form.sameAsPresentAddress" name="sameAddr" (ngModelChange)="onSameAddressChange()"> Same as Present</label>
                </div>
                <ng-container *ngIf="!form.sameAsPresentAddress">
                  <input class="ed-input" [(ngModel)]="form.permanentAddressLine1" name="permAddr1" (ngModelChange)="onFormChange()" placeholder="Address line 1">
                  <input class="ed-input" [(ngModel)]="form.permanentAddressLine2" name="permAddr2" (ngModelChange)="onFormChange()" placeholder="Address line 2">
                  <div class="ed-row">
                    <app-custom-select [(ngModel)]="form.permanentCountry" name="permCountry" (ngModelChange)="onPermanentCountryChange()" [options]="countries" placeholder="Country"></app-custom-select>
                    <app-custom-select [(ngModel)]="form.permanentState" name="permState" (ngModelChange)="onPermanentStateChange()" [disabled]="!form.permanentCountry" [options]="permanentStates" placeholder="State"></app-custom-select>
                  </div>
                  <div class="ed-row">
                    <app-custom-select [(ngModel)]="form.permanentCity" name="permCity" (ngModelChange)="onFormChange()" [disabled]="!form.permanentState" [options]="permanentCities" placeholder="City"></app-custom-select>
                    <input class="ed-input" [(ngModel)]="form.permanentPostalCode" name="permPostal" (ngModelChange)="onPermanentPostalChange()" placeholder="Postal code">
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Separation Information</div>
            <div class="ed-z-grid">
              <div class="ed-field"><label class="ed-label">Last Working Date</label>
                <app-date-picker label="" [(ngModel)]="form.lastWorkingDate" name="lastWorkingDate" (ngModelChange)="onFormChange()"></app-date-picker></div>
              <div class="ed-field"><label class="ed-label">Date of Exit</label>
                <app-date-picker label="" [(ngModel)]="form.dateOfExit" name="dateOfExit" (ngModelChange)="onFormChange()"></app-date-picker></div>
              <div class="ed-field ed-field-full"><label class="ed-label">Exit Remarks</label>
                <input class="ed-input" [(ngModel)]="form.exitRemarks" name="exitRemarks" (ngModelChange)="onFormChange()" placeholder="Remarks"></div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="empDrawerTab === 'education'">
          <div class="ed-z-sec">
            <div class="ed-z-title ed-z-title--row"><span><span class="ed-z-bar"></span>Work Experience</span>
              <button type="button" class="ed-add-row-btn" *ngIf="!isView" (click)="addExperienceRow()"><mat-icon>add</mat-icon> Add Row</button>
            </div>
            <div class="ed-edu-row" *ngFor="let row of experienceRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field"><label class="ed-label">Company Name</label><input class="ed-input" [(ngModel)]="row.company" [ngModelOptions]="{standalone:true}" placeholder="Company"></div>
                  <div class="ed-field"><label class="ed-label">Job Title</label><input class="ed-input" [(ngModel)]="row.occupation" [ngModelOptions]="{standalone:true}" placeholder="Job title"></div>
                </div>
                <div class="ed-row">
                  <div class="ed-field"><label class="ed-label">Duration</label><input class="ed-input" [(ngModel)]="row.duration" [ngModelOptions]="{standalone:true}" placeholder="e.g. Jan 2020 – Dec 2022"></div>
                  <div class="ed-field"><label class="ed-label">Relevant</label>
                    <app-custom-select [(ngModel)]="row.currentlyWorkHere" [ngModelOptions]="{standalone:true}" [options]="workHereOptions" placeholder="Select"></app-custom-select></div>
                </div>
                <div class="ed-field ed-field-full"><label class="ed-label">Job Description</label>
                  <textarea class="ed-input ed-textarea" [(ngModel)]="row.summary" [ngModelOptions]="{standalone:true}" rows="2" placeholder="Description"></textarea></div>
                <div class="ed-field ed-field-full">
                  <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Attachment (Experience Letter)" docType="experience_attachment" [employeeId]="form.id" [doc]="rowDoc(row)" (uploaded)="onRowUpload(row, $event)" (removed)="onRowRemove(row)"></app-doc-attach></div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeExperienceRow(i)" *ngIf="experienceRows.length > 1 && !isView"><mat-icon>delete_outline</mat-icon></button>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title ed-z-title--row"><span><span class="ed-z-bar"></span>Education Details</span>
              <button type="button" class="ed-add-row-btn" *ngIf="!isView" (click)="addEducationRow()"><mat-icon>add</mat-icon> Add Row</button>
            </div>
            <div class="ed-edu-row" *ngFor="let row of educationRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field"><label class="ed-label">Institute Name</label><input class="ed-input" [(ngModel)]="row.schoolName" [ngModelOptions]="{standalone:true}" placeholder="Institute"></div>
                  <div class="ed-field"><label class="ed-label">Degree / Diploma</label><input class="ed-input" [(ngModel)]="row.degree" [ngModelOptions]="{standalone:true}" placeholder="Degree"></div>
                </div>
                <div class="ed-row">
                  <div class="ed-field"><label class="ed-label">Specialization</label><input class="ed-input" [(ngModel)]="row.fieldOfStudy" [ngModelOptions]="{standalone:true}" placeholder="Specialization"></div>
                  <div class="ed-field"><label class="ed-label">Date of Completion</label><input class="ed-input" [(ngModel)]="row.dateOfCompletion" [ngModelOptions]="{standalone:true}" placeholder="e.g. May 2022"></div>
                </div>
                <div class="ed-field ed-field-full">
                  <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Attachment (Certificate / Marksheet)" docType="education_attachment" [employeeId]="form.id" [doc]="rowDoc(row)" (uploaded)="onRowUpload(row, $event)" (removed)="onRowRemove(row)"></app-doc-attach></div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeEducationRow(i)" *ngIf="educationRows.length > 1 && !isView"><mat-icon>delete_outline</mat-icon></button>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title ed-z-title--row"><span><span class="ed-z-bar"></span>Dependent Details</span>
              <button type="button" class="ed-add-row-btn" *ngIf="!isView" (click)="addDependentRow()"><mat-icon>add</mat-icon> Add Row</button>
            </div>
            <div class="ed-edu-row" *ngFor="let row of dependentRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field"><label class="ed-label">Name</label><input class="ed-input" [(ngModel)]="row.name" [ngModelOptions]="{standalone:true}" placeholder="Name"></div>
                  <div class="ed-field"><label class="ed-label">Relationship</label><input class="ed-input" [(ngModel)]="row.relationship" [ngModelOptions]="{standalone:true}" placeholder="e.g. Mother"></div>
                </div>
                <div class="ed-row">
                  <div class="ed-field"><label class="ed-label">Date of Birth</label><app-date-picker label="" [maxDate]="today" [(ngModel)]="row.dateOfBirth" [ngModelOptions]="{standalone:true}"></app-date-picker></div>
                  <div class="ed-field"><label class="ed-label">Contact No.</label><input class="ed-input" [(ngModel)]="row.contactNo" [ngModelOptions]="{standalone:true}" placeholder="Phone"></div>
                </div>
                <div class="ed-field ed-field-full"><label class="ed-label">Emergency Contact</label>
                  <app-custom-select [(ngModel)]="row.emergencyContact" [ngModelOptions]="{standalone:true}" [options]="emergencyOptions" placeholder="Select"></app-custom-select></div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeDependentRow(i)" *ngIf="dependentRows.length > 1 && !isView"><mat-icon>delete_outline</mat-icon></button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="empDrawerTab === 'documents'">
          <div class="ed-z-sec" *ngIf="empDocs.length">
            <div class="ed-z-title"><span class="ed-z-bar"></span>All Documents ({{ empDocs.length }})</div>
            <div class="ed-attach-grid">
              <app-doc-attach *ngFor="let d of empDocs" [readonly]="isView" [downloadPrefix]="downloadPrefix"
                [label]="docTypeLabel(d.documentType)" [doc]="d" [employeeId]="form.id"
                (changed)="loadDocuments()"></app-doc-attach>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Company Documents</div>
            <div class="ed-attach-grid">
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Signed Offer Letter" docType="offer_letter" [employeeId]="form.id" [doc]="findDoc('offer_letter')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Signed Appointment Letter" docType="appointment_letter" [employeeId]="form.id" [doc]="findDoc('appointment_letter')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Signed Bond" docType="bond" [employeeId]="form.id" [doc]="findDoc('bond')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Signed NDA" docType="nda" [employeeId]="form.id" [doc]="findDoc('nda')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="BGV Report" docType="bgv_report" [employeeId]="form.id" [doc]="findDoc('bgv_report')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>ESIC / Medical</div>
            <div class="ed-attach-grid">
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="ESIC Card" docType="esic_card" [employeeId]="form.id" [doc]="findDoc('esic_card')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Medical Acceptance Card" docType="medical_acceptance" [employeeId]="form.id" [doc]="findDoc('medical_acceptance')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title ed-z-title--row"><span><span class="ed-z-bar"></span>Health Care</span>
              <button type="button" class="ed-add-row-btn" *ngIf="!isView" (click)="addHealthRow()"><mat-icon>add</mat-icon> Add Row</button>
            </div>
            <div class="ed-edu-row" *ngFor="let row of healthRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field"><label class="ed-label">Name</label><input class="ed-input" [(ngModel)]="row.name" [ngModelOptions]="{standalone:true}" placeholder="Plan / member name"></div>
                  <div class="ed-field">
                    <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Health Care Document" docType="healthcare_attachment" [employeeId]="form.id" [doc]="rowDoc(row)" (uploaded)="onRowUpload(row, $event)" (removed)="onRowRemove(row)"></app-doc-attach></div>
                </div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeHealthRow(i)" *ngIf="healthRows.length > 1 && !isView"><mat-icon>delete_outline</mat-icon></button>
            </div>
          </div>

          <div class="ed-z-sec">
            <div class="ed-z-title"><span class="ed-z-bar"></span>System Fields</div>
            <div class="ed-z-grid">
              <div class="ed-field"><label class="ed-label">Onboarding Status</label>
                <input class="ed-input ed-input-readonly" [(ngModel)]="form.onboardingStatus" name="onboardingStatusRo" placeholder="Not Triggered" readonly></div>
            </div>
          </div>

          <div class="ed-z-sec" *ngIf="formMode === 'add'">
            <div class="ed-z-title"><span class="ed-z-bar"></span>Login Credentials</div>
            <div class="ed-field ed-field-full"><label class="ed-label">Password</label>
              <input class="ed-input" [(ngModel)]="form.password" name="password" (ngModelChange)="onFormChange()" placeholder="Password"></div>
            <div class="ed-credentials" *ngIf="form.generatedPassword">
              <mat-icon>vpn_key</mat-icon>
              <div><strong>Auto-generated Credentials</strong>
                <p>Email: <code>{{ form.email || '-' }}</code></p>
                <p>Password: <code>{{ form.generatedPassword }}</code></p>
                <small>Share with the employee after saving.</small>
              </div>
            </div>
          </div>
        </ng-container>

      </fieldset>

      <div *ngIf="legacyView && empDrawerTab === 'personal'" class="ed-section">

        <ng-container *ngIf="formMode === 'view'">
          <div class="ed-info-grid">
            <div class="ed-info-item">
              <span class="ed-info-label">Email</span>
              <span class="ed-info-val">{{ form.email || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Official Email</span>
              <span class="ed-info-val">{{ form.officialEmail || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Phone</span>
              <span class="ed-info-val">{{ form.phone || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Gender</span>
              <span class="ed-info-val">{{ (form.gender | titlecase) || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Date of Birth</span>
              <span class="ed-info-val">{{ form.dateOfBirth || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">UAN Number</span>
              <span class="ed-info-val">{{ form.uanNumber || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Aadhaar</span>
              <span class="ed-info-val">{{ form.aadhaarNumber || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">PAN</span>
              <span class="ed-info-val">{{ form.panNumber || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Role</span>
              <span class="ed-info-val">{{ (form.role | titlecase) || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Reporting Manager</span>
              <span class="ed-info-val">{{ getManagerName(form.managerId) || '-' }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.personalEmail">
              <span class="ed-info-label">Personal Email</span>
              <span class="ed-info-val">{{ form.personalEmail }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.personalMobile">
              <span class="ed-info-label">Personal Mobile</span>
              <span class="ed-info-val">{{ form.personalMobile }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.maritalStatus">
              <span class="ed-info-label">Marital Status</span>
              <span class="ed-info-val">{{ form.maritalStatus | titlecase }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.bloodGroup">
              <span class="ed-info-label">Blood Group</span>
              <span class="ed-info-val">{{ form.bloodGroup }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.passportNumber">
              <span class="ed-info-label">Passport No.</span>
              <span class="ed-info-val">{{ form.passportNumber }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.creationSource">
              <span class="ed-info-label">Added Via</span>
              <span class="ed-info-val">{{ form.creationSource === 'bulk_upload' ? 'Bulk Upload' : (form.creationSource | titlecase) }}</span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="formMode !== 'view'">
          <div class="ed-field-group">
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">First Name <span class="ed-req">*</span></label>
                <input class="ed-input" [(ngModel)]="form.firstName" name="firstName" (ngModelChange)="onFormChange()" placeholder="First name"
                  [class.ed-input-err]="submitting && !form.firstName">
                <span class="ed-err" *ngIf="submitting && !form.firstName">Required</span>
              </div>
              <div class="ed-field">
                <label class="ed-label">Last Name <span class="ed-req">*</span></label>
                <input class="ed-input" [(ngModel)]="form.lastName" name="lastName" (ngModelChange)="onFormChange()" placeholder="Last name"
                  [class.ed-input-err]="submitting && !form.lastName">
                <span class="ed-err" *ngIf="submitting && !form.lastName">Required</span>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Email ID <span class="ed-req" *ngIf="formMode==='add'">*</span></label>
                <input type="email" class="ed-input"
                  [(ngModel)]="form.email" name="email"
                  (ngModelChange)="onFormChange()"
                  placeholder="Personal / login email"
                  [class.ed-input-err]="submitting && !form.email && formMode==='add'">
                <span class="ed-hint" *ngIf="formMode==='edit'">Used for login. Replace with official email once the work account is created.</span>
                <span class="ed-err" *ngIf="submitting && !form.email && formMode==='add'">Required</span>
              </div>
              <div class="ed-field">
                <label class="ed-label">Official Email</label>
                <input class="ed-input" [(ngModel)]="form.officialEmail" name="officialEmail" (ngModelChange)="onFormChange()" placeholder="Company email (e.g. name@company.com)">
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Phone</label>
                <input class="ed-input" [(ngModel)]="form.phone" name="phone" (ngModelChange)="onFormChange()"
                  maxlength="10" (keypress)="allowOnlyNumbers($event)" (input)="enforceMaxLength($event, 'phone')"
                  placeholder="10-digit number"
                  [class.ed-input-err]="form.phone && (form.phone.length < 10 || isPhoneDuplicate())">
                <span class="ed-err" *ngIf="form.phone && form.phone.length > 0 && form.phone.length < 10">{{ form.phone.length }}/10 digits</span>
                <span class="ed-err" *ngIf="form.phone?.length === 10 && isPhoneDuplicate()">Phone already exists</span>
                <span class="ed-ok" *ngIf="form.phone?.length === 10 && !isPhoneDuplicate()">&#10003; Valid</span>
              </div>
              <div class="ed-field">
                <label class="ed-label">Gender</label>
                <app-quick-add-select category="gender" [seedOptions]="genderOptions" [(ngModel)]="form.gender"
                  name="gender" (ngModelChange)="onFormChange()" placeholder="Select Gender"></app-quick-add-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Date of Birth</label>
                <app-date-picker label="" [maxDate]="today" [(ngModel)]="form.dateOfBirth" name="dateOfBirth" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
              <div class="ed-field">
                <label class="ed-label">Role</label>
                <app-custom-select [(ngModel)]="form.role" name="role" (ngModelChange)="onFormChange()"
                  [options]="roleSelectOptions" placeholder="Select Role"></app-custom-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Employee ID</label>
                <input class="ed-input ed-input-readonly" [(ngModel)]="form.employeeId" name="employeeId"
                  [placeholder]="form.employeeId ? '' : 'Auto-generated'" readonly>
              </div>
              <div class="ed-field">
                <label class="ed-label">Reporting Manager</label>
                <app-custom-select [(ngModel)]="form.managerId" name="managerId" (ngModelChange)="onFormChange()"
                  [options]="managersList" bindValue="id" [labelFn]="empNameFn" placeholder="Select Manager"></app-custom-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Aadhaar Number</label>
                <input class="ed-input" [(ngModel)]="form.aadhaarNumber" name="aadhaarNumber" (ngModelChange)="onFormChange()" placeholder="Aadhaar card number">
              </div>
              <div class="ed-field">
                <label class="ed-label">PAN Number</label>
                <input class="ed-input" [(ngModel)]="form.panNumber" name="panNumber" (ngModelChange)="onFormChange()" placeholder="PAN card number">
              </div>
            </div>
            <div class="ed-attach-title">Identity Attachments</div>
            <div class="ed-attach-grid">
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Aadhaar Card" docType="aadhaar" [employeeId]="form.id" [doc]="findDoc('aadhaar')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="PAN Card" docType="pan" [employeeId]="form.id" [doc]="findDoc('pan')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Cancelled Cheque" docType="cancelled_cheque" [employeeId]="form.id" [doc]="findDoc('cancelled_cheque')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Passport" docType="passport" [employeeId]="form.id" [doc]="findDoc('passport')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Photo" docType="photo" [employeeId]="form.id" [doc]="findDoc('photo')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">UAN Number</label>
                <input class="ed-input" [(ngModel)]="form.uanNumber" name="uanNumber" (ngModelChange)="onFormChange()" placeholder="UAN number">
              </div>
              <div class="ed-field" *ngIf="formMode === 'add'">
                <label class="ed-label">Status</label>
                <app-quick-add-select category="employee_status" [seedOptions]="statusOptions" [(ngModel)]="form.status"
                  name="status" (ngModelChange)="onFormChange()" placeholder="Select Status"></app-quick-add-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Middle Name</label>
                <input class="ed-input" [(ngModel)]="form.middleName" name="middleName" (ngModelChange)="onFormChange()" placeholder="Middle name">
              </div>
              <div class="ed-field">
                <label class="ed-label">Nick Name</label>
                <input class="ed-input" [(ngModel)]="form.nickName" name="nickName" (ngModelChange)="onFormChange()" placeholder="Nick name">
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Personal Email</label>
                <input class="ed-input" [(ngModel)]="form.personalEmail" name="personalEmail" (ngModelChange)="onFormChange()" placeholder="Personal email">
              </div>
              <div class="ed-field">
                <label class="ed-label">Personal Mobile</label>
                <input class="ed-input" [(ngModel)]="form.personalMobile" name="personalMobile" (ngModelChange)="onFormChange()" placeholder="Personal mobile">
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Marital Status</label>
                <app-quick-add-select category="marital_status" [(ngModel)]="form.maritalStatus"
                  name="maritalStatus" (ngModelChange)="onFormChange()" placeholder="Select Marital Status"></app-quick-add-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">Blood Group</label>
                <app-quick-add-select category="blood_group" [(ngModel)]="form.bloodGroup"
                  name="bloodGroup" (ngModelChange)="onFormChange()" placeholder="Select Blood Group"></app-quick-add-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Passport No.</label>
                <input class="ed-input" [(ngModel)]="form.passportNumber" name="passportNumber" (ngModelChange)="onFormChange()" placeholder="Passport number">
              </div>
              <div class="ed-field">
                <label class="ed-label">Passport Valid Until</label>
                <app-date-picker label="" [(ngModel)]="form.passportValidUntil" name="passportValidUntil" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Citizenship</label>
                <app-quick-add-select category="citizenship" [(ngModel)]="form.citizenship"
                  name="citizenship" (ngModelChange)="onFormChange()" placeholder="Select Citizenship"></app-quick-add-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">Wedding Day</label>
                <app-date-picker label="" [(ngModel)]="form.weddingDay" name="weddingDay" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Work Phone</label>
                <input class="ed-input" [(ngModel)]="form.workPhone" name="workPhone" (ngModelChange)="onFormChange()" placeholder="Work phone">
              </div>
              <div class="ed-field">
                <label class="ed-label">Extension</label>
                <input class="ed-input" [(ngModel)]="form.extension" name="extension" (ngModelChange)="onFormChange()" placeholder="Extension">
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Secondary Reporting Manager</label>
                <app-custom-select [(ngModel)]="form.secondaryReportingManagerId" name="secondaryReportingManagerId" (ngModelChange)="onFormChange()"
                  [options]="managersList" bindValue="id" [labelFn]="empNameFn" placeholder="Select Manager"></app-custom-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">Tags</label>
                <input class="ed-input" [(ngModel)]="form.tags" name="tags" (ngModelChange)="onFormChange()" placeholder="Comma-separated tags">
              </div>
            </div>
            <div class="ed-row" *ngIf="formMode === 'add'">
              <div class="ed-field ed-field-full">
                <label class="ed-label">Password</label>
                <input class="ed-input" [(ngModel)]="form.password" name="password" (ngModelChange)="onFormChange()" placeholder="Password">
              </div>
            </div>
            <div class="ed-credentials" *ngIf="formMode === 'add' && form.generatedPassword">
              <mat-icon>vpn_key</mat-icon>
              <div>
                <strong>Auto-generated Credentials</strong>
                <p>Email: <code>{{ form.email || '-' }}</code></p>
                <p>Password: <code>{{ form.generatedPassword }}</code></p>
                <small>Share with the employee after saving.</small>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="legacyView && empDrawerTab === 'professional'" class="ed-section">

        <ng-container *ngIf="formMode === 'view'">
          <div class="ed-info-grid">
            <div class="ed-info-item">
              <span class="ed-info-label">Department</span>
              <span class="ed-info-val">{{ getDeptName(form.departmentId) || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Designation</span>
              <span class="ed-info-val">{{ form.designation || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Employment Type</span>
              <span class="ed-info-val">{{ (form.employmentType | titlecase) || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Location</span>
              <span class="ed-info-val">{{ form.location || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Experience</span>
              <span class="ed-info-val">{{ form.experience || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Current Salary</span>
              <span class="ed-info-val">{{ form.currentSalary ? (form.currentSalary | number) : '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Date of Joining</span>
              <span class="ed-info-val">{{ form.dateOfJoining || '-' }}</span>
            </div>
            <div class="ed-info-item">
              <span class="ed-info-label">Source of Hire</span>
              <span class="ed-info-val">{{ form.sourceOfHire || '-' }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.grade">
              <span class="ed-info-label">Grade</span>
              <span class="ed-info-val">{{ form.grade }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.clientName">
              <span class="ed-info-label">Client</span>
              <span class="ed-info-val">{{ form.clientName }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.project">
              <span class="ed-info-label">Project</span>
              <span class="ed-info-val">{{ form.project }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.billable">
              <span class="ed-info-label">Billable</span>
              <span class="ed-info-val">{{ form.billable }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.bgvStatus">
              <span class="ed-info-label">BGV Status</span>
              <span class="ed-info-val">{{ form.bgvStatus }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.onboardingStatus">
              <span class="ed-info-label">Onboarding</span>
              <span class="ed-info-val">{{ form.onboardingStatus }}</span>
            </div>
            <div class="ed-info-item" *ngIf="form.noticePeriodDays">
              <span class="ed-info-label">Notice Period</span>
              <span class="ed-info-val">{{ form.noticePeriodDays }} days</span>
            </div>
            <div class="ed-info-item" *ngIf="form.seatingLocation">
              <span class="ed-info-label">Seating Location</span>
              <span class="ed-info-val">{{ form.seatingLocation }}</span>
            </div>
          </div>

          <div class="ed-info-block" *ngIf="form.bond || form.commitmentStartDate || form.commitmentEndDate">
            <span class="ed-info-label">Bond / Commitment</span>
            <div class="ed-info-grid" style="margin-top:8px">
              <div class="ed-info-item" *ngIf="form.bond">
                <span class="ed-info-label">Bond</span>
                <span class="ed-info-val">{{ form.bond }}</span>
              </div>
              <div class="ed-info-item" *ngIf="form.commitmentStartDate">
                <span class="ed-info-label">Commitment Start</span>
                <span class="ed-info-val">{{ form.commitmentStartDate }}</span>
              </div>
              <div class="ed-info-item" *ngIf="form.commitmentEndDate">
                <span class="ed-info-label">Commitment End</span>
                <span class="ed-info-val">{{ form.commitmentEndDate }}</span>
              </div>
            </div>
          </div>
          <div class="ed-info-block" *ngIf="form.linkedinProfile">
            <span class="ed-info-label">LinkedIn</span>
            <p class="ed-info-text"><a [href]="form.linkedinProfile" target="_blank" rel="noopener">{{ form.linkedinProfile }}</a></p>
          </div>
          <div class="ed-info-block" *ngIf="form.skillSet">
            <span class="ed-info-label">Skill Set</span>
            <p class="ed-info-text">{{ form.skillSet }}</p>
          </div>
          <div class="ed-info-block" *ngIf="form.additionalInfo">
            <span class="ed-info-label">Additional Info</span>
            <p class="ed-info-text">{{ form.additionalInfo }}</p>
          </div>
        </ng-container>

        <ng-container *ngIf="formMode !== 'view'">
          <div class="ed-field-group">
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Department</label>
                <app-custom-select [(ngModel)]="form.departmentId" name="departmentId"
                  (ngModelChange)="onDepartmentChange()" [options]="departments"
                  bindLabel="name" bindValue="id" placeholder="Select Department"></app-custom-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">Designation</label>
                <app-quick-add-select category="designation" [(ngModel)]="form.designation"
                  name="designation" (ngModelChange)="onFormChange()" placeholder="Select Designation"></app-quick-add-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Team</label>
                <app-custom-select [(ngModel)]="form.teamId" name="teamId" (ngModelChange)="onFormChange()"
                  [options]="filteredTeams" bindLabel="name" bindValue="id" placeholder="Select Team"></app-custom-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">Employment Type</label>
                <app-quick-add-select category="employment_type" [(ngModel)]="form.employmentType"
                  name="employmentType" (ngModelChange)="onFormChange()" placeholder="Select Type"></app-quick-add-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Location</label>
                <app-quick-add-select category="location" [(ngModel)]="form.location"
                  name="location" (ngModelChange)="onFormChange()" placeholder="Select Location"></app-quick-add-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">Zoho Role</label>
                <app-quick-add-select category="zoho_role" [(ngModel)]="form.zohoRole"
                  name="zohoRole" (ngModelChange)="onFormChange()" placeholder="Select Role"></app-quick-add-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Experience</label>
                <input class="ed-input" [(ngModel)]="form.experience" name="experience" (ngModelChange)="onFormChange()" placeholder="e.g. 3 years">
              </div>
              <div class="ed-field">
                <label class="ed-label">Date of Confirmation</label>
                <app-date-picker label="" [(ngModel)]="form.dateOfConfirmation" name="dateOfConfirmation" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Date of Joining</label>
                <app-date-picker label="" [(ngModel)]="form.dateOfJoining" name="dateOfJoining" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
              <div class="ed-field">
                <label class="ed-label">Tentative Joining</label>
                <app-date-picker label="" [(ngModel)]="form.tentativeJoiningDate" name="tentativeJoiningDate" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Current Salary</label>
                <input type="number" class="ed-input" [(ngModel)]="form.currentSalary" name="currentSalary" (ngModelChange)="onFormChange()" placeholder="Amount">
              </div>
              <div class="ed-field">
                <label class="ed-label">Source of Hire</label>
                <app-quick-add-select category="source_of_hire" [(ngModel)]="form.sourceOfHire"
                  name="sourceOfHire" (ngModelChange)="onFormChange()" placeholder="Select Source"></app-quick-add-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Highest Qualification</label>
                <input class="ed-input" [(ngModel)]="form.highestQualification" name="highestQualification" (ngModelChange)="onFormChange()" placeholder="Qualification">
              </div>
              <div class="ed-field">
                <label class="ed-label">Title</label>
                <div class="ed-radio-group">
                  <label *ngFor="let t of titles" class="ed-radio-item">
                    <input type="radio" [(ngModel)]="form.title" name="title" [value]="t" (ngModelChange)="onFormChange()">
                    {{ t }}
                  </label>
                </div>
              </div>
            </div>
            <div class="ed-field ed-field-full">
              <label class="ed-label">Skill Set</label>
              <textarea class="ed-input ed-textarea" [(ngModel)]="form.skillSet" name="skillSet" rows="3"
                (ngModelChange)="onFormChange()" placeholder="e.g. Angular, Java, Spring Boot"></textarea>
            </div>
            <div class="ed-field ed-field-full">
              <label class="ed-label">Additional Info</label>
              <textarea class="ed-input ed-textarea" [(ngModel)]="form.additionalInfo" name="additionalInfo" rows="3"
                (ngModelChange)="onFormChange()" placeholder="Any additional notes"></textarea>
            </div>

            <div class="ed-addr-section-title" style="margin-top:18px">Additional Details</div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Grade</label>
                <input class="ed-input" [(ngModel)]="form.grade" name="grade" (ngModelChange)="onFormChange()" placeholder="e.g. C2">
              </div>
              <div class="ed-field">
                <label class="ed-label">Seating Location</label>
                <input class="ed-input" [(ngModel)]="form.seatingLocation" name="seatingLocation" (ngModelChange)="onFormChange()" placeholder="e.g. Mumbai">
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Client Name</label>
                <input class="ed-input" [(ngModel)]="form.clientName" name="clientName" (ngModelChange)="onFormChange()" placeholder="Client">
              </div>
              <div class="ed-field">
                <label class="ed-label">Project</label>
                <input class="ed-input" [(ngModel)]="form.project" name="project" (ngModelChange)="onFormChange()" placeholder="Project">
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Billable</label>
                <app-quick-add-select category="billable" [seedOptions]="billableOptions" [(ngModel)]="form.billable"
                  name="billable" (ngModelChange)="onFormChange()" placeholder="Select"></app-quick-add-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">BGV Status</label>
                <app-quick-add-select category="bgv_status" [(ngModel)]="form.bgvStatus"
                  name="bgvStatus" (ngModelChange)="onFormChange()" placeholder="Select BGV Status"></app-quick-add-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Current Experience</label>
                <input class="ed-input ed-input-readonly" [(ngModel)]="form.currentExperience" name="currentExperience" placeholder="Auto-calculated" readonly>
              </div>
              <div class="ed-field">
                <label class="ed-label">Total Experience</label>
                <input class="ed-input ed-input-readonly" [(ngModel)]="form.totalExperience" name="totalExperience" placeholder="Auto-calculated" readonly>
              </div>
            </div>
            <div class="ed-field ed-field-full">
              <label class="ed-label">Notice Period (days)</label>
              <input type="number" class="ed-input" [(ngModel)]="form.noticePeriodDays" name="noticePeriodDays" (ngModelChange)="onFormChange()" placeholder="e.g. 90">
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">LinkedIn Profile</label>
                <input class="ed-input" [(ngModel)]="form.linkedinProfile" name="linkedinProfile" (ngModelChange)="onFormChange()" placeholder="LinkedIn URL">
              </div>
              <div class="ed-field">
                <label class="ed-label">Certifications</label>
                <input class="ed-input" [(ngModel)]="form.certifications" name="certifications" (ngModelChange)="onFormChange()" placeholder="Certifications">
              </div>
            </div>

            <div class="ed-addr-section-title" style="margin-top:14px">Bond / Commitment (Intern & Contract)</div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Bond</label>
                <input class="ed-input" [(ngModel)]="form.bond" name="bond" (ngModelChange)="onFormChange()" placeholder="e.g. 2 years">
              </div>
              <div class="ed-field">
                <label class="ed-label">Commitment Start</label>
                <app-date-picker label="" [(ngModel)]="form.commitmentStartDate" name="commitmentStartDate" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Commitment End</label>
                <app-date-picker label="" [(ngModel)]="form.commitmentEndDate" name="commitmentEndDate" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
              <div class="ed-field">
                <label class="ed-label">Last Working Date</label>
                <app-date-picker label="" [(ngModel)]="form.lastWorkingDate" name="lastWorkingDate" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
            </div>

            <div class="ed-addr-section-title" style="margin-top:14px">Separation Information</div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Date of Exit</label>
                <app-date-picker label="" [(ngModel)]="form.dateOfExit" name="dateOfExit" (ngModelChange)="onFormChange()"></app-date-picker>
              </div>
              <div class="ed-field">
                <label class="ed-label">Onboarding Status</label>
                <input class="ed-input ed-input-readonly" [(ngModel)]="form.onboardingStatus" name="onboardingStatusRo" placeholder="Not Triggered" readonly>
              </div>
            </div>
            <div class="ed-field ed-field-full">
              <label class="ed-label">Exit Remarks</label>
              <textarea class="ed-input ed-textarea" [(ngModel)]="form.exitRemarks" name="exitRemarks" rows="2"
                (ngModelChange)="onFormChange()" placeholder="Reason / remarks for exit"></textarea>
            </div>

            <div class="ed-attach-title" style="margin-top:18px">Company Documents</div>
            <div class="ed-attach-grid">
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Signed Offer Letter" docType="offer_letter" [employeeId]="form.id" [doc]="findDoc('offer_letter')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Signed Appointment Letter" docType="appointment_letter" [employeeId]="form.id" [doc]="findDoc('appointment_letter')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Signed Bond" docType="bond" [employeeId]="form.id" [doc]="findDoc('bond')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Signed NDA" docType="nda" [employeeId]="form.id" [doc]="findDoc('nda')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="BGV Report" docType="bgv_report" [employeeId]="form.id" [doc]="findDoc('bgv_report')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
            </div>

            <div class="ed-attach-title" style="margin-top:18px">ESIC / Medical</div>
            <div class="ed-attach-grid">
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="ESIC Card" docType="esic_card" [employeeId]="form.id" [doc]="findDoc('esic_card')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
              <app-doc-attach [readonly]="isView" [downloadPrefix]="downloadPrefix" label="Medical Acceptance Card" docType="medical_acceptance" [employeeId]="form.id" [doc]="findDoc('medical_acceptance')" (changed)="loadDocuments()" (pendingChange)="onPendingDoc($event)" [deferrable]="true"></app-doc-attach>
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="legacyView && empDrawerTab === 'address'" class="ed-section">

        <ng-container *ngIf="formMode === 'view'">
          <div class="ed-addr-view-block">
            <div class="ed-addr-view-title">Present Address</div>
            <p class="ed-addr-view-text">
              {{ getAddressString([form.presentAddressLine1, form.presentAddressLine2, form.presentCity, form.presentState, form.presentCountry, form.presentPostalCode]) || form.presentAddress || '-' }}
            </p>
          </div>
          <div class="ed-addr-view-block">
            <div class="ed-addr-view-title">Permanent Address</div>
            <p class="ed-addr-view-text">
              {{ form.sameAsPresentAddress ? 'Same as present address' : (getAddressString([form.permanentAddressLine1, form.permanentAddressLine2, form.permanentCity, form.permanentState, form.permanentCountry, form.permanentPostalCode]) || form.permanentAddress || '-') }}
            </p>
          </div>
          <div class="ed-addr-view-block" style="margin-top:8px">
            <div class="ed-addr-view-title">Emergency Contact</div>
            <div class="ed-info-grid" style="margin-top:10px">
              <div class="ed-info-item">
                <span class="ed-info-label">Name</span>
                <span class="ed-info-val">{{ form.emergencyContactName || '-' }}</span>
              </div>
              <div class="ed-info-item">
                <span class="ed-info-label">Phone</span>
                <span class="ed-info-val">{{ form.emergencyContactPhone || '-' }}</span>
              </div>
              <div class="ed-info-item">
                <span class="ed-info-label">Relation</span>
                <span class="ed-info-val">{{ form.emergencyRelation || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="ed-addr-view-block" style="margin-top:8px">
            <div class="ed-addr-view-title">Bank Details</div>
            <div class="ed-info-grid" style="margin-top:10px">
              <div class="ed-info-item">
                <span class="ed-info-label">Bank Name</span>
                <span class="ed-info-val">{{ form.bankName || '-' }}</span>
              </div>
              <div class="ed-info-item">
                <span class="ed-info-label">Account Number</span>
                <span class="ed-info-val">{{ form.bankAccount || '-' }}</span>
              </div>
              <div class="ed-info-item">
                <span class="ed-info-label">IFSC Code</span>
                <span class="ed-info-val">{{ form.ifscCode || '-' }}</span>
              </div>
              <div class="ed-info-item">
                <span class="ed-info-label">Branch</span>
                <span class="ed-info-val">{{ form.branchName || '-' }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="formMode !== 'view'">
          <div class="ed-field-group">
            <ng-container *ngIf="form.presentAddress || form.permanentAddress">
              <div class="ed-addr-section-title">Imported Address (raw)</div>
              <div class="ed-field ed-field-full">
                <label class="ed-label">Present Address (as imported)</label>
                <textarea class="ed-input ed-textarea" [(ngModel)]="form.presentAddress" name="presentAddressRaw" rows="2" (ngModelChange)="onFormChange()"></textarea>
              </div>
              <div class="ed-field ed-field-full">
                <label class="ed-label">Permanent Address (as imported)</label>
                <textarea class="ed-input ed-textarea" [(ngModel)]="form.permanentAddress" name="permanentAddressRaw" rows="2" (ngModelChange)="onFormChange()"></textarea>
              </div>
            </ng-container>
            <div class="ed-addr-section-title">Present Address</div>
            <div class="ed-field ed-field-full">
              <label class="ed-label">Address Line 1</label>
              <input class="ed-input" [(ngModel)]="form.presentAddressLine1" name="presentAddr1"
                (ngModelChange)="onFormChange()" placeholder="Street address">
            </div>
            <div class="ed-field ed-field-full">
              <label class="ed-label">Address Line 2</label>
              <input class="ed-input" [(ngModel)]="form.presentAddressLine2" name="presentAddr2"
                (ngModelChange)="onFormChange()" placeholder="Apartment, suite, etc.">
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Country</label>
                <app-custom-select [(ngModel)]="form.presentCountry" name="presentCountry"
                  (ngModelChange)="onPresentCountryChange()" [options]="countries" placeholder="Select Country"></app-custom-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">State</label>
                <app-custom-select [(ngModel)]="form.presentState" name="presentState"
                  (ngModelChange)="onPresentStateChange()" [disabled]="!form.presentCountry"
                  [options]="presentStates" placeholder="Select State"></app-custom-select>
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">City</label>
                <app-custom-select [(ngModel)]="form.presentCity" name="presentCity"
                  (ngModelChange)="onFormChange()" [disabled]="!form.presentState"
                  [options]="presentCities" placeholder="Select City"></app-custom-select>
              </div>
              <div class="ed-field">
                <label class="ed-label">Postal Code</label>
                <div class="ed-postal-wrap">
                  <input class="ed-input" [(ngModel)]="form.presentPostalCode" name="presentPostal"
                    (ngModelChange)="onPresentPostalChange()" placeholder="Enter PIN / ZIP">
                  <span class="ed-postal-spinner" *ngIf="postalLookupLoading.present">
                    <mat-spinner diameter="14"></mat-spinner>
                  </span>
                </div>
                <span class="ed-err" *ngIf="postalLookupError.present">{{ postalLookupError.present }}</span>
                <span class="ed-ok" *ngIf="!postalLookupError.present && !postalLookupLoading.present && form.presentPostalCode?.length >= 5 && form.presentCity">&#10003; Filled</span>
              </div>
            </div>

            <div class="ed-addr-section-title" style="margin-top:20px">Permanent Address</div>
            <div class="ed-same-addr-check">
              <mat-checkbox [(ngModel)]="form.sameAsPresentAddress" name="sameAddr"
                (ngModelChange)="onSameAddressChange()">Same as present address</mat-checkbox>
            </div>
            <ng-container *ngIf="!form.sameAsPresentAddress">
              <div class="ed-field ed-field-full">
                <label class="ed-label">Address Line 1</label>
                <input class="ed-input" [(ngModel)]="form.permanentAddressLine1" name="permAddr1"
                  (ngModelChange)="onFormChange()" placeholder="Street address">
              </div>
              <div class="ed-field ed-field-full">
                <label class="ed-label">Address Line 2</label>
                <input class="ed-input" [(ngModel)]="form.permanentAddressLine2" name="permAddr2"
                  (ngModelChange)="onFormChange()" placeholder="Apartment, suite, etc.">
              </div>
              <div class="ed-row">
                <div class="ed-field">
                  <label class="ed-label">Country</label>
                  <app-custom-select [(ngModel)]="form.permanentCountry" name="permCountry"
                    (ngModelChange)="onPermanentCountryChange()" [options]="countries" placeholder="Select Country"></app-custom-select>
                </div>
                <div class="ed-field">
                  <label class="ed-label">State</label>
                  <app-custom-select [(ngModel)]="form.permanentState" name="permState"
                    (ngModelChange)="onPermanentStateChange()" [disabled]="!form.permanentCountry"
                    [options]="permanentStates" placeholder="Select State"></app-custom-select>
                </div>
              </div>
              <div class="ed-row">
                <div class="ed-field">
                  <label class="ed-label">City</label>
                  <app-custom-select [(ngModel)]="form.permanentCity" name="permCity"
                    (ngModelChange)="onFormChange()" [disabled]="!form.permanentState"
                    [options]="permanentCities" placeholder="Select City"></app-custom-select>
                </div>
                <div class="ed-field">
                  <label class="ed-label">Postal Code</label>
                  <div class="ed-postal-wrap">
                    <input class="ed-input" [(ngModel)]="form.permanentPostalCode" name="permPostal"
                      (ngModelChange)="onPermanentPostalChange()" placeholder="Enter PIN / ZIP">
                    <span class="ed-postal-spinner" *ngIf="postalLookupLoading.permanent">
                      <mat-spinner diameter="14"></mat-spinner>
                    </span>
                  </div>
                  <span class="ed-err" *ngIf="postalLookupError.permanent">{{ postalLookupError.permanent }}</span>
                  <span class="ed-ok" *ngIf="!postalLookupError.permanent && !postalLookupLoading.permanent && form.permanentPostalCode?.length >= 5 && form.permanentCity">&#10003; Filled</span>
                </div>
              </div>
            </ng-container>

            <div class="ed-addr-section-title" style="margin-top:20px">Bank Details</div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Bank Name</label>
                <input class="ed-input" [(ngModel)]="form.bankName" name="bankName" (ngModelChange)="onFormChange()" placeholder="e.g. HDFC Bank">
              </div>
              <div class="ed-field">
                <label class="ed-label">Account Number</label>
                <input class="ed-input" [(ngModel)]="form.bankAccount" name="bankAccount" (ngModelChange)="onFormChange()" placeholder="Bank account number">
              </div>
            </div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">IFSC Code</label>
                <input class="ed-input" [(ngModel)]="form.ifscCode" name="ifscCode" (ngModelChange)="onFormChange()" placeholder="IFSC code">
              </div>
              <div class="ed-field">
                <label class="ed-label">Branch</label>
                <input class="ed-input" [(ngModel)]="form.branchName" name="branchName" (ngModelChange)="onFormChange()" placeholder="Branch name">
              </div>
            </div>

            <div class="ed-addr-section-title" style="margin-top:20px">Emergency Contact</div>
            <div class="ed-row">
              <div class="ed-field">
                <label class="ed-label">Name</label>
                <input class="ed-input" [(ngModel)]="form.emergencyContactName" name="emergencyContactName" (ngModelChange)="onFormChange()" placeholder="Contact name">
              </div>
              <div class="ed-field">
                <label class="ed-label">Phone</label>
                <input class="ed-input" [(ngModel)]="form.emergencyContactPhone" name="emergencyContactPhone" (ngModelChange)="onFormChange()" placeholder="Contact phone">
              </div>
            </div>
            <div class="ed-field ed-field-full">
              <label class="ed-label">Relation</label>
              <input class="ed-input" [(ngModel)]="form.emergencyRelation" name="emergencyRelation" (ngModelChange)="onFormChange()" placeholder="e.g. Father / Spouse">
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="legacyView && empDrawerTab === 'education'" class="ed-section">

        <div class="ed-table-section">
          <div class="ed-table-header">
            <span class="ed-table-title">Education</span>
            <button type="button" class="ed-add-row-btn" (click)="addEducationRow()" *ngIf="formMode !== 'view'">
              <mat-icon>add</mat-icon> Add Row
            </button>
          </div>
          <div class="ed-edu-list">
            <div class="ed-edu-row" *ngFor="let row of educationRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field">
                    <label class="ed-label">School / Institution</label>
                    <input class="ed-input" [(ngModel)]="row.schoolName" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="School name">
                  </div>
                  <div class="ed-field">
                    <label class="ed-label">Degree / Diploma</label>
                    <input class="ed-input" [(ngModel)]="row.degree" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="Degree">
                  </div>
                </div>
                <div class="ed-row">
                  <div class="ed-field">
                    <label class="ed-label">Field of Study</label>
                    <input class="ed-input" [(ngModel)]="row.fieldOfStudy" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="e.g. Computer Science">
                  </div>
                  <div class="ed-field">
                    <label class="ed-label">Date of Completion</label>
                    <input type="date" class="ed-input" [(ngModel)]="row.dateOfCompletion"
                      [ngModelOptions]="{standalone:true}" [readonly]="formMode==='view'">
                  </div>
                </div>
                <div class="ed-field ed-field-full">
                  <label class="ed-label">Notes</label>
                  <input class="ed-input" [(ngModel)]="row.notes" [ngModelOptions]="{standalone:true}"
                    [readonly]="formMode==='view'" placeholder="Notes">
                </div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeEducationRow(i)"
                *ngIf="formMode !== 'view' && educationRows.length > 1">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="ed-table-section" style="margin-top:24px">
          <div class="ed-table-header">
            <span class="ed-table-title">Work Experience</span>
            <button type="button" class="ed-add-row-btn" (click)="addExperienceRow()" *ngIf="formMode !== 'view'">
              <mat-icon>add</mat-icon> Add Row
            </button>
          </div>
          <div class="ed-edu-list">
            <div class="ed-edu-row" *ngFor="let row of experienceRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field">
                    <label class="ed-label">Occupation / Role</label>
                    <input class="ed-input" [(ngModel)]="row.occupation" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="Job title">
                  </div>
                  <div class="ed-field">
                    <label class="ed-label">Company</label>
                    <input class="ed-input" [(ngModel)]="row.company" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="Company name">
                  </div>
                </div>
                <div class="ed-row">
                  <div class="ed-field">
                    <label class="ed-label">Duration</label>
                    <input class="ed-input" [(ngModel)]="row.duration" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="e.g. Jan 2020 -- Dec 2022">
                  </div>
                  <div class="ed-field">
                    <label class="ed-label">Currently Working Here</label>
                    <app-custom-select [(ngModel)]="row.currentlyWorkHere" [ngModelOptions]="{standalone:true}"
                      [disabled]="formMode==='view'" [options]="workHereOptions" placeholder="Select"></app-custom-select>
                  </div>
                </div>
                <div class="ed-field ed-field-full">
                  <label class="ed-label">Summary</label>
                  <textarea class="ed-input ed-textarea" [(ngModel)]="row.summary" [ngModelOptions]="{standalone:true}"
                    [readonly]="formMode==='view'" rows="2" placeholder="Brief description"></textarea>
                </div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeExperienceRow(i)"
                *ngIf="formMode !== 'view' && experienceRows.length > 1">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="ed-table-section" style="margin-top:24px">
          <div class="ed-table-header">
            <span class="ed-table-title">Dependent Details</span>
            <button type="button" class="ed-add-row-btn" (click)="addDependentRow()" *ngIf="formMode !== 'view'">
              <mat-icon>add</mat-icon> Add Row
            </button>
          </div>
          <div class="ed-edu-list">
            <div class="ed-edu-row" *ngFor="let row of dependentRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field">
                    <label class="ed-label">Name</label>
                    <input class="ed-input" [(ngModel)]="row.name" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="Dependent name">
                  </div>
                  <div class="ed-field">
                    <label class="ed-label">Relationship</label>
                    <input class="ed-input" [(ngModel)]="row.relationship" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="e.g. Mother / Spouse">
                  </div>
                </div>
                <div class="ed-row">
                  <div class="ed-field">
                    <label class="ed-label">Date of Birth</label>
                    <input type="date" class="ed-input" [(ngModel)]="row.dateOfBirth"
                      [ngModelOptions]="{standalone:true}" [readonly]="formMode==='view'">
                  </div>
                  <div class="ed-field">
                    <label class="ed-label">Contact No.</label>
                    <input class="ed-input" [(ngModel)]="row.contactNo" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="Phone number">
                  </div>
                </div>
                <div class="ed-field ed-field-full">
                  <label class="ed-label">Emergency Contact</label>
                  <app-custom-select [(ngModel)]="row.emergencyContact" [ngModelOptions]="{standalone:true}"
                    [disabled]="formMode==='view'" [options]="emergencyOptions" placeholder="Select"></app-custom-select>
                </div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeDependentRow(i)"
                *ngIf="formMode !== 'view' && dependentRows.length > 1">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="ed-table-section" style="margin-top:24px">
          <div class="ed-table-header">
            <span class="ed-table-title">Health Care</span>
            <button type="button" class="ed-add-row-btn" (click)="addHealthRow()" *ngIf="formMode !== 'view'">
              <mat-icon>add</mat-icon> Add Row
            </button>
          </div>
          <div class="ed-edu-list">
            <div class="ed-edu-row" *ngFor="let row of healthRows; let i = index">
              <div class="ed-edu-num">{{ i + 1 }}</div>
              <div class="ed-edu-fields">
                <div class="ed-row">
                  <div class="ed-field">
                    <label class="ed-label">Name</label>
                    <input class="ed-input" [(ngModel)]="row.name" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="Plan / member name">
                  </div>
                  <div class="ed-field">
                    <label class="ed-label">Document URL</label>
                    <input class="ed-input" [(ngModel)]="row.docUrl" [ngModelOptions]="{standalone:true}"
                      [readonly]="formMode==='view'" placeholder="Link to uploaded doc (use Documents tab)">
                  </div>
                </div>
              </div>
              <button type="button" class="ed-remove-row" (click)="removeHealthRow(i)"
                *ngIf="formMode !== 'view' && healthRows.length > 1">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="legacyView && empDrawerTab === 'documents'" class="ed-section ed-docs-section">

        <div class="ed-docs-upload-bar">
          <select class="ed-docs-type-select" [(ngModel)]="docUploadType" name="docUploadType">
            <option value="">Select document type…</option>
            <option value="aadhaar">Aadhaar Card</option>
            <option value="pan">PAN Card</option>
            <option value="cancelled_cheque">Cancelled Cheque</option>
            <option value="photo">Passport Photo</option>
            <option value="passport">Passport</option>
            <option value="offer_letter">Signed Offer Letter</option>
            <option value="appointment_letter">Signed Appointment Letter</option>
            <option value="bond">Signed Bond</option>
            <option value="nda">Signed NDA</option>
            <option value="bgv_report">BGV Report</option>
            <option value="esic_card">ESIC Card</option>
            <option value="medical_acceptance">Medical Acceptance Card</option>
            <option value="experience_letter">Experience Letter</option>
            <option value="education_cert">Education Certificate</option>
            <option value="other">Other</option>
          </select>
          <label class="ed-docs-upload-btn" [class.disabled]="!docUploadType || docUploading">
            <mat-icon>upload_file</mat-icon>
            {{ docUploading ? 'Uploading...' : 'Choose File' }}
            <input type="file" style="display:none" (change)="onDocFileSelected($event)"
              [disabled]="!docUploadType || docUploading"
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx">
          </label>
          <span class="ed-docs-hint">PDF, JPG, PNG, DOC up to 5 MB</span>
        </div>

        <div class="ed-docs-loading" *ngIf="docsLoading">
          <div class="ed-docs-sk" *ngFor="let x of [1,2,3]">
            <div class="ed-docs-sk-icon dsk-pulse"></div>
            <div class="ed-docs-sk-lines">
              <div class="dsk-pulse" style="width:140px;height:13px;border-radius:4px"></div>
              <div class="dsk-pulse" style="width:80px;height:11px;border-radius:4px;margin-top:5px"></div>
            </div>
          </div>
        </div>

        <div class="ed-imported-docs" *ngIf="!docsLoading && importedDocs.length > 0">
          <div class="ed-imported-head">
            <mat-icon>cloud_off</mat-icon>
            <div>
              <strong>Imported from Zoho — re-upload needed</strong>
              <span>These were migrated as links that require a Zoho login. Re-upload the real file to store it in NovarcPulse.</span>
            </div>
          </div>
          <div class="ed-doc-row ed-doc-row--imported" *ngFor="let d of importedDocs">
            <div class="ed-doc-icon ed-doc-icon--warn"><mat-icon>description</mat-icon></div>
            <div class="ed-doc-info">
              <div class="ed-doc-name">{{ d.name || d.type }}</div>
              <div class="ed-doc-meta">
                <span class="ed-doc-type-chip ed-doc-type-chip--warn">Needs re-upload</span>
                <a class="ed-doc-srclink" *ngIf="d.sourceUrl" [href]="d.sourceUrl" target="_blank" rel="noopener">
                  <mat-icon style="font-size:12px;width:12px;height:12px">open_in_new</mat-icon> Original (Zoho)
                </a>
              </div>
            </div>
            <div class="ed-doc-actions">
              <label class="ed-doc-btn ed-doc-btn--reupload" matTooltip="Re-upload this document"
                     *ngIf="canEditEmployee()" (click)="docUploadType = docCanonicalType(d.type)">
                <mat-icon>upload</mat-icon>
                <input type="file" hidden (change)="onDocFileSelected($event)"
                       accept=".pdf,.jpg,.jpeg,.png,.doc,.docx">
              </label>
            </div>
          </div>
        </div>

        <div class="ed-docs-empty" *ngIf="!docsLoading && empDocs.length === 0 && importedDocs.length === 0">
          <mat-icon>folder_open</mat-icon>
          <p>No documents uploaded yet</p>
          <span>Use the upload button above to attach Aadhaar, PAN, offer letter, etc.</span>
        </div>

        <div class="ed-docs-list" *ngIf="!docsLoading && empDocs.length > 0">
          <div class="ed-doc-row" *ngFor="let doc of empDocs">
            <div class="ed-doc-icon" [ngClass]="getDocIconClass(doc.mimeType)">
              <mat-icon>{{ getDocIcon(doc.mimeType) }}</mat-icon>
            </div>
            <div class="ed-doc-info">
              <div class="ed-doc-name">{{ doc.fileName }}</div>
              <div class="ed-doc-meta">
                <span class="ed-doc-type-chip">{{ docTypeLabel(doc.documentType) }}</span>
                <span class="ed-doc-size">{{ formatFileSize(doc.fileSize) }}</span>
                <span class="ed-doc-date">{{ doc.uploadedAt | date:'dd MMM yyyy' }}</span>
                <span class="ed-doc-expiry" *ngIf="doc.expiryDate" [class.ed-doc-expired]="isExpired(doc.expiryDate)">
                  <mat-icon style="font-size:11px;width:11px;height:11px">event</mat-icon>
                  Expires {{ doc.expiryDate | date:'dd MMM yyyy' }}
                </span>
              </div>
              <div class="ed-doc-notes" *ngIf="doc.notes">{{ doc.notes }}</div>
            </div>
            <div class="ed-doc-actions">
              <button type="button" class="ed-doc-btn ed-doc-btn--download" matTooltip="Download"
                (click)="downloadDoc(doc)">
                <mat-icon>download</mat-icon>
              </button>
              <button type="button" class="ed-doc-btn ed-doc-btn--delete" matTooltip="Delete"
                (click)="deleteDoc(doc.id)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>

      </div>

    </form>
  </div>

  <div class="ed-footer" *ngIf="formMode !== 'view'">
    <button type="button" class="ed-btn-cancel" (click)="closeDialog()">Cancel</button>
    <button type="button" class="ed-btn-submit" (click)="submitEmployee()" [disabled]="submitting">
      {{ submitting ? 'Saving...' : (formMode === 'add' ? 'Add Employee' : 'Save Changes') }}
    </button>
  </div>
  <div class="ed-footer" *ngIf="formMode === 'view'">
    <button type="button" class="ed-btn-cancel" (click)="closeDialog()">Close</button>
    <button type="button" class="ed-btn-submit" *ngIf="canEditEmployee()"
      (click)="formMode='edit'; editingId=form.id; formSnapshot='{}'; formDirty=false; empDrawerTab='personal'">
      <mat-icon style="font-size:16px;width:16px;height:16px;vertical-align:middle">edit</mat-icon> Edit Employee
    </button>
  </div>

</div>

<div class="ecl-overlay" *ngIf="showClientModal" (click)="closeClientModal()">
  <div class="ecl-modal" (click)="$event.stopPropagation()">
    <div class="ecl-head"><span>Add Client</span><button type="button" class="ecl-x" (click)="closeClientModal()">&times;</button></div>
    <div class="ecl-body">
      <div class="ed-field"><label class="ed-label">Client Name <i>*</i></label>
        <input class="ed-input" [(ngModel)]="clientModalForm.name" [ngModelOptions]="{standalone:true}" placeholder="Client name"></div>
      <div class="ed-field"><label class="ed-label">Email <i>*</i></label>
        <input class="ed-input" [(ngModel)]="clientModalForm.email" [ngModelOptions]="{standalone:true}" placeholder="client@example.com"></div>
      <label class="ed-label" style="margin-top:6px;display:block">Projects</label>
      <div class="ecl-proj" *ngFor="let p of clientModalProjects; let i = index; trackBy: trackByIndex">
        <input class="ed-input" [(ngModel)]="clientModalProjects[i]" [ngModelOptions]="{standalone:true}" placeholder="Project name — e.g. GRC">
        <button type="button" class="ecl-proj-del" (click)="removeClientProject(i)" *ngIf="clientModalProjects.length > 1">&times;</button>
      </div>
      <button type="button" class="ecl-proj-add" (click)="addClientProject()">+ Add Project</button>
    </div>
    <div class="ecl-foot">
      <button type="button" class="ed-btn-cancel" (click)="closeClientModal()">Cancel</button>
      <button type="button" class="ed-btn-submit" [disabled]="clientModalSaving" (click)="saveNewClient()">{{ clientModalSaving ? 'Saving…' : 'Add Client' }}</button>
    </div>
  </div>
</div>
